import { concantQuery } from '@/utils/concatQuery'
import EventEmitter from '@/utils/EventEmitter'
import api from './api'

export const UserManagerEventEmitter = new EventEmitter()

const wsEvents = {
  USER_MANAGER_DELETE_USER: 'USER_MANAGER_DELETE_USER',
  USER_MANAGER_UPDATE_USER: 'USER_MANAGER_UPDATE_USER',
  USER_MANAGER_ADD_USER: 'USER_MANAGER_ADD_USER',
  USER_MANAGER_UPDATE_USER_CAR: 'USER_MANAGER_UPDATE_USER_CAR',
  USER_MANAGER_NEW_USER_CAR: 'USER_MANAGER_NEW_USER_CAR'
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => UserManagerEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    UserManagerEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_USER_MANAGER: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_USER_MANAGER'))
  },
  ACTION_DELETE_USER: (...args) => {
    wrapAction(() => wsActions.socket.emit('ACTION_DELETE_USER', ...args))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => UserManagerEventEmitter.emit(eventName, args))
  })

  wsActions.socket = socket
}

/**
 * Get users.
 * @param {*} param0
 * @returns
*/
const loadUsers = ({ limit, offset, search }) => {
  const query = concantQuery({ limit, offset, search })
  return api.get(`/statistical/users${query}`)
}

export {
  loadUsers,
  bindWsEvents,
  wsEvents,
  wsListeners,
  wsActions
}
